import { render, staticRenderFns } from "./confirmDelete.vue?vue&type=template&id=68d2de2c&"
import script from "./confirmDelete.vue?vue&type=script&lang=js&"
export * from "./confirmDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports